import { useEffect, useState } from 'react';
import { ExtendedGallery } from '../../../../../pages/HomepageRedesign/components';
import { ReviewsCarouselItem } from '../ReviewsCarouselItem';
import { AnimatePresence, motion } from 'motion/react';

import type { ReviewCategory } from '../categories';
import type { ReviewsCarouselItemProps } from '../reviewsData';

import styles from './MobileReviewsCarousel.module.css';

type MobileReviewsCarouselProps = {
  selectedCategory: ReviewCategory;
  items: ReviewsCarouselItemProps[];
};

export const MobileReviewsCarousel = ({
  items,
  selectedCategory,
}: MobileReviewsCarouselProps) => {
  const [activeItem, setActiveItem] = useState(1);

  const safeActiveItem = Math.max(0, Math.min(activeItem, items.length - 1));

  const handleSlideChange = (index: number) => {
    setActiveItem(index);
  };

  useEffect(() => {
    setActiveItem(1);
  }, [selectedCategory]);

  return (
    <ExtendedGallery
      withDots
      isWide={false}
      id="reviews-carousel"
      label="User Testimonials"
      className={styles.gallery}
      activeIndex={safeActiveItem}
      slideClassname={styles.slide}
      onSlideChange={handleSlideChange}
    >
      {items.map((item, index) => (
        <AnimatePresence key={item.id} mode="wait">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            <ReviewsCarouselItem
              {...item}
              isActive={index === safeActiveItem}
            />
          </motion.div>
        </AnimatePresence>
      ))}
    </ExtendedGallery>
  );
};
